import { makeObservable, observable, action, computed, runInAction } from 'mobx';
import i18n from 'src/i18n';

import { SuccessToast, ErrorToast } from 'src/libs/toast';
import ChapterService from 'src/services/chapter';
import ChapterError from 'src/services/error/models/chapter';
import AlertViewModel from '../Alert/viewModel';
import ChapterSelectorModalViewModel from '../ChapterSelectorModal/viewModel';

export default class CommentModalViewModel extends AlertViewModel {
  @observable isLoading = true;
  @observable chapterList = [];

  @observable id;
  @observable courseId;

  @observable chapterCache = {};
  @observable chapter = { id: 'all', name: i18n.t('course_tab_comments_sheet_title') };
  @observable chapterName;
  @observable chapterAnchor = null;

  @observable comment;
  @observable commentCache;

  @observable isProcessing = false;

  @observable chapterSelectorModalVm = new ChapterSelectorModalViewModel();

  constructor(props) {
    super(props);

    makeObservable(this);
  }

  @action
  didMount = async (cid) => {
    this.courseId = cid;
    await this.getChapters();
  }

  @action
  getChapters = async () => {
    try {
      const { list, anchor } = await ChapterService.getAvailableChapters(this.courseId, this.chapterAnchor);
      runInAction(() => {
        this.chapterAnchor = anchor;
        this.chapterList.push(...list);
      });
    } catch (error) {
      ChapterError.getAvailableChapters(error);
    }
  }

  @action
  onOpen = (data) => {
    this.isLoading = true;
    this.handlerOpenAlert();

    this.id = null;
    this.courseId = data.courseId;
    this.chapter = this.chapterList.some((el) => el.id === data.chapter.id) ? data.chapter : { id: 'all', name: i18n.t('course_tab_comments_sheet_title') };
    this.chapterCache = this.chapter;
    this.comment = '';
    this.commentCache = '';

    this.isLoading = false;
  }

  @action
  onEditOpen = (data) => {
    this.isLoading = true;
    this.handlerOpenAlert();

    this.id = data.id;
    this.courseId = data.courseId;
    this.chapter = data.chapter;

    this.comment = data.comment;
    this.commentCache = data.comment;

    this.isLoading = false;
  }

  @action
  onCancelClick = () => {
    this.chapterCache = this.chapter;
    this.chapterSelectorModalVm.handlerCloseAlert();
  }

  @action
  handleConfirm = async (afterConfirmFunc) => {
    try {
      this.isProcessing = true;
      if (this.chapterId === 'all') {
        ErrorToast(i18n.t('course_tab_comments_select_error'));
        this.isProcessing = false;
        return;
      }
      if (!this.commentCache.trim()) {
        ErrorToast(i18n.t('course_tab_comments_error1'));
        this.isProcessing = false;
        return;
      }

      if (this.commentCache === this.comment) {
        return;
      }

      if (!this.id) {
        const res = await ChapterService.postNewComment(this.chapter.id, this.commentCache);
        runInAction(() => {
          SuccessToast(i18n.t('course_tab_comments_add_success'));
          afterConfirmFunc({ ...res, comment: { ...res.comment, chapter: { ...res.comment.chapter, id: res.comment.chapter._id } } });
          this.isProcessing = false;
        });
      } else {
        const res = await ChapterService.editComment(this.chapter.id, this.id, this.commentCache);
        runInAction(() => {
          SuccessToast(i18n.t('course_tab_comments_edit_success'));
          afterConfirmFunc(res);
          this.isProcessing = false;
        });
      }
      this.handleClose();
    } catch (error) {
      console.error(error);
      this.isProcessing = false;
    }
  }

  @action
  handleClose = () => {
    this.handlerCloseAlert();
  }

  @action
  onSelectItem = (el) => {
    this.chapterCache = el;
  }

  @action
  onSelectConfirm = () => {
    this.chapter = this.chapterCache;
    this.chapterSelectorModalVm.handlerConfirmCloseAlert();
  }

  @action
  handleCommentChange = (e) => {
    this.commentCache = e.target.value;
  }
}
